import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'aid-upload-file-simple',
  template: `
    @if (fileControl.invalid) {
      <div
        class="border-dashed border-radius-8 pointer padding-16 aid-layout-column aid-layout-align-center-center"
        (click)="onFile()"
      >
        <mat-icon
          svgIcon="upload"
          color="primary"
          class="container__icon"
        ></mat-icon>
        <span class="mat-subtitle-2"> {{ title | translate }}</span>
        <span class="mat-small basic-color-600">
          {{ description | translate }}
        </span>
      </div>
    }

    @if (fileControl.valid) {
      <div class="aid-layout-row aid-layout-align-space-between-center">
        <div class="mat-subtitle-2">{{ fileName }}</div>
        <button mat-icon-button (click)="onRemoveFile()">
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      </div>
    }

    <input
      style="display: none"
      type="file"
      #file
      (change)="onAddFile(file.files)"
      [accept]="accept"
    />
  `,
  styleUrls: ['./upload-file-simple.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UploadFileSimpleComponent implements OnInit {
  @Input() title?: string;
  @Input() description?: string;
  @Input() accept = 'text/csv';
  @Input({ required: true }) fileControl = new UntypedFormControl();

  @Output() uploaded = new EventEmitter();
  @Output() removed = new EventEmitter();

  form?: UntypedFormGroup;
  @ViewChild('file') file?: ElementRef<HTMLInputElement>;

  constructor() {}

  ngOnInit() {}

  get fileName() {
    const file: File = this.fileControl.value;
    return file.name;
  }

  onAddFile(files: FileList | null) {
    this.fileControl.setValue(files?.[0]);
    this.uploaded.emit();
  }

  onRemoveFile() {
    this.fileInput.value = '';
    this.fileControl.setValue(null);

    this.removed.emit();
  }

  onFile() {
    this.fileInput.click();
  }

  private get fileInput(): HTMLInputElement {
    if (!this.file) {
      throw new Error(
        'aid-upload-file-simple: the file input is not rendered.'
      );
    }
    return this.file.nativeElement;
  }
}
